











import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bListGroup from 'bootstrap-vue/es/components/list-group/list-group';

import DEMO_DATA from '@/demo-data';

import SideMenuItem from './SideMenuItem.vue';

@Component({
  components: {
    SideMenuItem,

    bListGroup,
  },
})
export default class SideMenu extends Vue {
  public readonly navigations = DEMO_DATA.menu;
}
